import { advancedConfigurationFilteredOwners } from 'app.constants';
import { ConfigurationFeatures } from '../ConfigurationFeatures';
export class AdvancedConfigurationsController {
    static $inject = ['CallerConfigurationService', 'ConfigurationsService', 'LoadingService', '$translate', 'ngToast', 'application', 'AlertService', '$state'];
    constructor(CallerConfigurationService, ConfigurationsService, LoadingService, $translate, ngToast, application, AlertService, $state) {
        'ngInject';
        this.CallerConfigurationService = CallerConfigurationService;
        this.ConfigurationsService = ConfigurationsService;
        this.LoadingService = LoadingService;
        this.$translate = $translate;
        this.ngToast = ngToast;
        this.AlertService = AlertService;
        this.$state = $state;
        this.filterOwnersInAdvancedConfigurations = false;
        this.blockAddViewPluginsAdvancedBotConfiguration = false;
        this.useConfigurationApplicationGet = false;
        this.useConfigurationApplicationSet = false;
        this.advancedConfigurationFilteredOwnersList = [];
        this.application = application;
        this.init();
    }
    async init() {
        try {
            this.LoadingService.startLoading();
            const filteredOwners = advancedConfigurationFilteredOwners;
            if (filteredOwners) {
                this.advancedConfigurationFilteredOwnersList = filteredOwners.split(',');
            }
            await this.checkFeatures();
            await this.getConfigurations();
        }
        catch (e) {
            this.ngToast.error(await this.$translate('utils.errorMsg.3'));
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async checkFeatures() {
        this.filterOwnersInAdvancedConfigurations = await ConfigurationFeatures.isFilteringOwnersInAdvancedConfigurations();
        this.blockAddViewPluginsAdvancedBotConfiguration = await ConfigurationFeatures.isBlockAddViewPluginsAdvancedBotConfiguration();
        this.useConfigurationApplicationGet = await ConfigurationFeatures.isConfigurationDomainOnAdvancedConfigurationPropertiesGetEnabled();
        this.useConfigurationApplicationSet = await ConfigurationFeatures.isConfigurationDomainOnAdvancedConfigurationPropertiesSetEnabled();
    }
    async getConfigurations() {
        const configurationsResult = (await this.CallerConfigurationService.get(this.application.shortName + '@msging.net', this.useConfigurationApplicationGet)).items.map((o) => {
            return { domain: o.owner, key: o.name, value: o.value };
        });
        if (this.filterOwnersInAdvancedConfigurations) {
            const filteredConfigurations = configurationsResult.filter((configuration) => {
                return !this.advancedConfigurationFilteredOwnersList.includes(configuration.domain);
            });
            this.configurations = filteredConfigurations;
        }
        else {
            this.configurations = configurationsResult;
        }
        if (this.blockAddViewPluginsAdvancedBotConfiguration) {
            this.configurations = this.configurations.filter((item) => {
                return !item.key.includes('Plugins');
            });
        }
    }
    async showFilteredAdvancedConfigurationError() {
        await this.AlertService.show({
            variant: 'warning',
            icon: 'warning',
            title: await this.$translate('modules.application.detail.edit.filteredDomainAdvancedConfigurationError.title'),
            body: await this.$translate('modules.application.detail.edit.filteredDomainAdvancedConfigurationError.description'),
            buttons: {
                confirm: await this.$translate('modules.application.detail.edit.filteredDomainAdvancedConfigurationError.goToChannelsButton'),
                cancel: await this.$translate('modules.application.detail.edit.filteredDomainAdvancedConfigurationError.returnButton'),
            },
            callback: {
                cancelButtonAction: () => { },
                confirmButtonAction: () => {
                    this.$state.go('auth.application.detail.channels');
                },
            },
        });
    }
    async saveAdvancedConfiguration(configuration) {
        try {
            this.LoadingService.startLoading();
            this.newConfiguration = configuration || this.newConfiguration;
            //check if there is a plugin configuration to save
            if (this.blockAddViewPluginsAdvancedBotConfiguration && this.newConfiguration.key.includes('Plugins')) {
                throw new Error('It is not possible to add plugins directly from the bot is advanced settings screen. Use the Blip Store screen for this action');
            }
            //check if this is a builder bot
            if (this.application.template === 'builder' && this.newConfiguration.domain.includes('master.hosting@msging.net')) {
                throw new Error('using a master configuration in a builder template');
            }
            else {
                if (this.application.template === 'master' && this.newConfiguration.domain.includes('builder.hosting@msging.net')) {
                    throw new Error('using a builder configuration in a master template');
                }
                else if (this.filterOwnersInAdvancedConfigurations && this.advancedConfigurationFilteredOwnersList.includes(this.newConfiguration.domain)) {
                    await this.showFilteredAdvancedConfigurationError();
                    throw new Error('Filtered advanced configuration owner error');
                }
                else {
                    const resource = {};
                    resource[this.newConfiguration.key] = this.newConfiguration.value;
                    await this.ConfigurationsService.set(this.newConfiguration.domain, resource, undefined, this.useConfigurationApplicationSet);
                    this.resetState();
                    await this.getConfigurations();
                    this.ngToast.success(await this.$translate('modules.application.detail.edit.onAdvancedConfigurationSaved'));
                }
            }
        }
        catch (e) {
            if (e.message.includes('add plugins')) {
                this.ngToast.danger(await this.$translate('modules.application.detail.edit.KeyPluginsonAdvancedConfigurationError'));
            }
            else {
                this.ngToast.danger(await this.$translate('modules.application.detail.edit.onAdvancedConfigurationError'));
            }
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async deleteAdvancedConfiguration(configuration) {
        this.LoadingService.startLoading();
        try {
            await this.ConfigurationsService.deleteSingle(configuration.domain, configuration.key, undefined, this.useConfigurationApplicationSet);
            await this.getConfigurations();
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    clearForm(form) {
        this.resetState();
        form.$setPristine();
        form.$setUntouched();
    }
    resetState() {
        this.newConfiguration = undefined;
        this.errorMsg = undefined;
        this.STATE = undefined;
    }
}
AdvancedConfigurationsController.$inject = ['CallerConfigurationService', 'ConfigurationsService', 'LoadingService', '$translate', 'ngToast', 'application', 'AlertService', '$state'];
